import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Customized">
                <h1>Next-Gen Digital Healthcare Solutions</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  Put your mark in the global healthcare industry with our
                  comprehensive digital health solutions. We create innovative
                  digital healthcare solutions that enable you to streamline
                  medical operations with a guaranteed ROI growth of 2.5X.
                </p>
                <ul>
                  <li>Electronic Health Records (EHR)</li>
                  <li>Health Information Exchange (HIE)</li>
                  <li>Telemedicine and Telehealth</li>
                  <li>AR, VR & more.</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
